import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isPossibleNumber } from 'libphonenumber-js';
import Phone from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './style.scss';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { registrationActions } from 'careand-redux/slices/registration';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { RegistrationBottomNavigation } from 'scenes/PatientRegistration/Navigation';

const PhoneValidation = (props) => {
  const dispatch = useAppDispatch();
  const nav = useNavStack(Stacks.Master);

  const registration = useAppSelector((state) => state.registration);

  const { track, path } = props;

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (!registration.credentials || !registration.personalData) {
      props.goToStart();
    }
  }, [registration.credentials, registration.personalData]);

  useEffect(() => {
    track('registrationSMSSend');
  }, [track]);

  useEffect(() => {
    const { personalData = {}, credentials } = registration;
    let missingData = !personalData.first_name || !credentials.username;
    //TODO is this correct??
    if (missingData) nav.push(path);
  }, [registration, history, path]);

  async function goToVerificationStep(event) {
    if (event) event.preventDefault();
    if (isPossibleNumber(phone || '')) {
      setLoading(true);
      dispatch(registrationActions.saveRegistrationPhone(phone));
      const { isSuccess } = await dispatch(api.Authentication.sendPhoneVerification({ phone }), {
        errorTitle: 'Phone Confirmation',
        meta: true,
      });
      setLoading(false);
      if (isSuccess) {
        props.onSuccess();
      }
    }
  }

  return (
    <div className="phone step">
      <form id="phone-entry" className="phone-entry" onSubmit={goToVerificationStep}>
        <span className="top-text">
          We will send an SMS to this phone to verify your phone number
        </span>
        <Phone placeholder="Phone number" defaultCountry="CA" value={phone} onChange={setPhone} />
        <RegistrationBottomNavigation
          id="phone-entry-btn"
          loading={loading}
          disabled={!isPossibleNumber(phone || '')}
        />
      </form>
    </div>
  );
};

PhoneValidation.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
};

export default PhoneValidation;
